/* eslint-disable import/prefer-default-export */
export enum Regions {
  IAD = 'us-east-1',
  PDX = 'us-west-2',
  DUB = 'eu-west-1',
}
